import { useViewManager } from '../useViewManager';

export const useHasOrthographicView = () => {
  const { availableViews } = useViewManager();
  return availableViews.some((view) => view.cameraMode === 0);
};
